var _path, _rect, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopFitting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 114,
    viewBox: "0 0 45 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 1L22 41.6864L22 78",
    stroke: "#016DB0",
    strokeWidth: 0.799071,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.79 4.79"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.2437,
    y: 41.3267,
    width: 21.3414,
    height: 56.4572,
    stroke: "#7D7D7D",
    strokeWidth: 0.487345
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06594 24.2437H36.0509V37.1718C36.0509 39.4596 34.1962 41.3142 31.9084 41.3142H12.2084C9.92057 41.3142 8.06594 39.4596 8.06594 37.1718V24.2437Z",
    stroke: "#7D7D7D",
    strokeWidth: 0.487345
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5244 29.5884V36H29.2588V31.0474L27.7383 31.5308V30.5332L30.3882 29.5884H30.5244Z",
    fill: "#1F1F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8825 74.842L12.8825 74.842L20.1248 70.6602C21.5946 69.8115 23.4054 69.8115 24.8752 70.6602L32.1175 74.842L32.2425 74.6255L32.1175 74.842L39.3602 79.0231C40.8301 79.8716 41.7355 81.4399 41.7354 83.1371L41.735 91.5L41.7354 99.8629C41.7355 101.56 40.8301 103.128 39.3602 103.977L32.1175 108.158L32.2425 108.375L32.1175 108.158L24.8752 112.34C23.4054 113.188 21.5946 113.188 20.1248 112.34L12.8825 108.158L12.7575 108.375L12.8825 108.158L5.63978 103.977C4.16994 103.128 3.26449 101.56 3.26458 99.8629L3.265 91.5L3.26458 83.1371C3.26449 81.4399 4.16994 79.8716 5.63978 79.0231L12.8825 74.842Z",
    fill: "white",
    stroke: "#7D7D7D",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopFitting);
export default __webpack_public_path__ + "static/media/top-fitting.ab101a3f85696ed939f10410029f83b6.svg";
export { ForwardRef as ReactComponent };